var _path, _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRemoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.5h-.5v-.527c0-.212 0-.418.023-.588a.99.99 0 0 1 .27-.592.99.99 0 0 1 .592-.27c.17-.023.376-.023.588-.023H13.027c.212 0 .418 0 .588.023a.99.99 0 0 1 .592.27.99.99 0 0 1 .27.592c.023.17.023.376.023.588v.527H10Z",
    stroke: "#A9BBC9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 11,
    height: 19,
    rx: 1.5,
    transform: "matrix(1 0 0 -1 6 21)",
    stroke: "#A9BBC9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(1 0 0 -1 12 6)",
    fill: "#A9BBC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRemoxIcon);
export default __webpack_public_path__ + "static/media/mobile-remox-icon.a690d40290722df14befe8d9ef77fc4a.svg";
export { ForwardRef as ReactComponent };